import JournalEntryReportComponent from 'components/Report/JournalEntryReport';
import PermissionGuard from 'components/Global/PermissionGuard'; // adjust the path if necessary

const JournalEntryReport = () => {
	return (
		<PermissionGuard permission="Allow_Payroll_Reports">
			<JournalEntryReportComponent />
		</PermissionGuard>
	);
};

export default JournalEntryReport;
